import React from 'react';
import {Typography} from 'components/Typography';
import {ButtonNew} from 'components/ButtonNew';

export const ProductShowSimilarButton = () => {
    const onClick = () => {
        const similar = document.getElementById('similar');

        if (similar) {
            const similarTop = similar.offsetTop + 200;

            window.scrollTo({behavior: 'smooth', top: similarTop});
        }
    };

    return (
        <div>
            <ButtonNew isStretched={true} onClick={onClick} variant={'large'} theme={'black'}>
                <Typography variants={{DT: 'button-14-m-cl', TB: 'button-14-m-cl', MB: 'label-16-r'}}>
                    Найти замену
                </Typography>
            </ButtonNew>
        </div>
    );
};
